var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcSimpleswaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6377 31.4636L4.6908 21.5167C4.22794 21.0539 3.91271 20.4643 3.78498 19.8224C3.65725 19.1804 3.72275 18.5151 3.97321 17.9104C4.22368 17.3057 4.64784 16.7888 5.19206 16.4252C5.73627 16.0616 6.3761 15.8676 7.03061 15.8676L11.4267 15.8655L11.4281 6.76927C11.4283 5.89166 11.777 5.05005 12.3976 4.42948C13.0181 3.80892 13.8598 3.4602 14.7374 3.46001L18.0459 3.46071C18.9238 3.46072 19.7657 3.80945 20.3864 4.43019C21.0071 5.05093 21.3559 5.89283 21.3559 6.77068L21.3573 15.8655L25.7541 15.8655C26.4088 15.8652 27.0489 16.0591 27.5934 16.4226C28.1379 16.7862 28.5622 17.3032 28.8128 17.908C29.0634 18.5129 29.1289 19.1785 29.0011 19.8206C28.8732 20.4628 28.5578 21.0525 28.0946 21.5153L18.1463 31.4636C17.6809 31.9286 17.0499 32.1898 16.392 32.1898C15.7341 32.1898 15.1031 31.9286 14.6377 31.4636V31.4636Z",
    fill: "#03F5AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.237 4.569L38.1832 14.5152C38.6461 14.9779 38.9613 15.5676 39.089 16.2095C39.2168 16.8514 39.1512 17.5168 38.9008 18.1215C38.6503 18.7262 38.2262 19.243 37.6819 19.6066C37.1377 19.9702 36.4979 20.1643 35.8434 20.1642L31.4459 20.165L31.4452 29.2619C31.445 30.1395 31.0963 30.9811 30.4757 31.6017C29.8551 32.2222 29.0135 32.5709 28.1359 32.5711H24.8281C23.9502 32.5711 23.1083 32.2224 22.4876 31.6017C21.8668 30.9809 21.5181 30.139 21.5181 29.2612V20.165L17.1213 20.165C16.4666 20.1653 15.8265 19.9714 15.282 19.6078C14.7375 19.2442 14.3132 18.7273 14.0626 18.1224C13.812 17.5175 13.7465 16.8519 13.8743 16.2098C14.0022 15.5677 14.3176 14.9779 14.7808 14.5152L24.727 4.569C25.1924 4.10354 25.8237 3.84204 26.482 3.84204C27.1403 3.84204 27.7716 4.10354 28.237 4.569V4.569Z",
    fill: "#AC6AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.518 20.165H17.118C16.4636 20.1648 15.824 19.9705 15.2801 19.6067C14.7361 19.2428 14.3123 18.7259 14.0623 18.1212C13.8122 17.5164 13.7471 16.8511 13.8752 16.2094C14.0033 15.5677 14.3189 14.9784 14.782 14.516L21.355 7.94104V15.866H25.755C26.4095 15.866 27.0493 16.06 27.5936 16.4236C28.1378 16.7872 28.562 17.304 28.8125 17.9087C29.0629 18.5134 29.1285 19.1788 29.0008 19.8207C28.8731 20.4626 28.5578 21.0523 28.095 21.515L21.518 28.089V20.165Z",
    fill: "#72F5FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.872,
    height: 40,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSimpleswaps);
export default __webpack_public_path__ + "static/media/ic_simpleswaps.d09be5e1fd6665369e588f676c837f28.svg";
export { ForwardRef as ReactComponent };